// extracted by mini-css-extract-plugin
export default {"container":"Status_container__qLq33","title":"Status_title__xr8k4","table":"Status_table__ZWrvZ","menu":"Status_menu__UkGP9"};